import { render, staticRenderFns } from "./bankrupt-debts-form.vue?vue&type=template&id=2651739d&scoped=true&"
import script from "./bankrupt-debts-form.vue?vue&type=script&lang=js&"
export * from "./bankrupt-debts-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651739d",
  null
  
)

export default component.exports